import React, { useState, useEffect } from 'react';
import Header from "components/Headers/Header.js";
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, Button, Alert } from "reactstrap";
import { Form } from 'react-bootstrap';
import { format } from 'date-fns';
import Modal from "react-modal";
import { MapContainer, TileLayer, Marker, Popup,LayersControl, FeatureGroup } from 'react-leaflet';
import L from 'leaflet';

Modal.setAppElement("#root");

function FotoNormalUser() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [message, setMessage] = useState('');
    const [sensorsoptions, setSensorsoptions] = useState([]);
    const [sensors, setSensor] = useState('');
    const [dateoptions, setDateoptions] = useState([]);
    const [date, setDate] = useState('');
    const [sensordata, setSensordata] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedImage, setSelectedImage] = useState(null);
    
    const token = useSelector((state) => state.userLogin.userInfo.token);
    const { t, i18n } = useTranslation();  

    useEffect(() => {
        const storedLanguage = localStorage.getItem('selectedLanguageAFS');
        if (storedLanguage) {
            i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const config = { headers: { 'Content-type': 'application/json', Authorization: `Bearer ${token}` } };
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/list/`, config);
                setSensorsoptions(response.data);
            } catch (error) {
                setError(true);
                setMessage("Error fetching sensors");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [token]);

    const handleSelectChange1 = async (e) => {
        setSensor(e.target.value);
        try {
            const config = { headers: { 'Content-type': 'application/json', Authorization: `Bearer ${token}` } };
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/date-sensor-data-acquisition/${e.target.value}`, config);
            setDateoptions(response.data);
        } catch (error) {}
    };

    const handleSelectChange2 = async (e) => {
        setDate(e.target.value);
        try {
            const config = { headers: { 'Content-type': 'application/json', Authorization: `Bearer ${token}` } };
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/sensor-data-by-date/${sensors}/${e.target.value}`, config);
            setSensordata(response.data);
            setCurrentIndex(0);
        } catch (error) {}
    };

    const handleNextImage = () => {
        if (currentIndex < sensordata.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handlePrevImage = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    const redIcon = new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
    });

    const [loadingdownload, setLoadingdownload] = useState(true)

    const download = async(e) => {

        setLoadingdownload(false)

        try {
            // Effettua la richiesta GET specificando il responseType 'blob'
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_API}/sensors/download-all-data-photo/${sensors}/${date}`, // Assicurati che l'endpoint corrisponda a quello definito in Django
                {
                responseType: 'blob', // Importante per gestire dati binari (il file zip)
                headers: {
                    // Se usi autenticazione JWT, ad esempio:
                    Authorization: `Bearer ${token}`,
                },
                }
            );

            // Crea un oggetto Blob dall'array di byte ricevuto
            const blob = new Blob([response.data], { type: 'application/zip' });
            // Crea un URL temporaneo per il blob
            const url = window.URL.createObjectURL(blob);
            // Crea un elemento link per forzare il download
            const link = document.createElement('a');
            link.href = url;
            // Imposta il nome del file che verrà scaricato
            link.setAttribute('download', `acquisition_${sensors}_${date}.zip`);
            // Aggiungi il link al DOM e simula il click
            document.body.appendChild(link);
            link.click();
            // Pulizia: rimuovi il link e revoca l'URL creato
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Errore durante il download:', error);
        } finally {
            setLoadingdownload(true)
        }

    }

    return (
        <div>
            <Header/>
            {loading ? (
                <Container fluid className="text-center mt-5">
                    <Spinner>{t('Loading')}</Spinner>
                </Container>
            ) : (
                <Container fluid>
                    <Row>
                        <Col lg={3} className="text-center mt-5">
                            <Card>
                                <CardHeader><h3>{t('Analysis Setting')}</h3></CardHeader>
                                <CardBody>
                                    <Form>
                                        {error && <Alert color="danger">{message}</Alert>}
                                        <Form.Group>
                                            <Form.Label>{t('Select the sensor')}</Form.Label>
                                            <Form.Control as="select" onChange={handleSelectChange1} value={sensors}>
                                                <option value=""></option>
                                                {sensorsoptions.map((sensor) => (
                                                    <option key={sensor.id} value={sensor.id}>{sensor.id_sensor}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>   
                                        <br/>
                                        <Form.Group>
                                            <Form.Label>{t('Select the date')}</Form.Label>
                                            <Form.Control as="select" onChange={handleSelectChange2} value={date}>
                                                <option value=""></option>
                                                {dateoptions.map((d, index) => (
                                                    <option key={index} value={d.date}>{format(new Date(d.date), 'PPpp')}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                        <br></br>
                                        {sensordata.length > 0 && (
                                            <>
                                                {loadingdownload ? (
                                                    <>
                                                        <Button 
                                                            color='success' 
                                                            onClick={download}>
                                                                {t('Download')}
                                                        </Button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Button 
                                                            color='success' 
                                                            disabled>
                                                                {t('Downloading')}
                                                                <Spinner size={"sm"} />
                                                        </Button>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </Form>           
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={9} xl={9} xxl={9} className="text-center mt-5">
                            {sensordata && sensordata.length>0 ? (
                                <>
                                    <Card>
                                        <CardHeader>
                                            <h3>{t('Data Points Location')}</h3>
                                        </CardHeader>
                                        <CardBody>
                                            <MapContainer key={sensordata[0].group_acquisition+sensordata[0].id} center={[sensordata[0].y_coord, sensordata[0].x_coord]} zoom={15} style={{ height: '300px', width: '100%', margin: 0, padding: 0 }}>
                                                <LayersControl position="topright">
                                                    <LayersControl.BaseLayer checked name="OpenStreetMap">
                                                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
                                                    </LayersControl.BaseLayer>
                                                    <LayersControl.BaseLayer checked name="Satellite">
                                                        <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" attribution='&copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community' />
                                                    </LayersControl.BaseLayer>
                                                </LayersControl>
                                                {sensordata.map((farmer, index) => (
                                                    <FeatureGroup key={index}>
                                                        <Marker position={[farmer.y_coord, farmer.x_coord]} icon={redIcon}>
                                                            <Popup>
                                                                <p>{t('Crop :')} {t(`translation:${farmer.crop}`)}</p>
                                                                <p>{t('Number of Grape :')} {farmer.count}</p>
                                                                <p>{t('Date Time of Data Acquisition :')} {format(new Date(farmer.date), 'PPpp')}</p>                   
                                                                {farmer.image1 ? <img src={farmer.image1} alt="Photo 1" style={{ height: '50%', width: '50%', objectFit: 'cover', cursor: 'pointer' }}/> : <p>No photo saved</p> }
                                                                {farmer.image2 ? <img src={farmer.image2} alt="Photo 2" style={{ height: '50%', width: '50%', objectFit: 'cover', cursor: 'pointer' }}/> : <p>No photo saved</p> }                   
                                                            </Popup>
                                                        </Marker>
                                                    </FeatureGroup>
                                                ))}
                                            </MapContainer>
                                        </CardBody>
                                    </Card>
                                </>
                            ):null}
                        </Col>
                        <Col lg={12} className="text-center mt-5">
                            <hr></hr>
                        </Col>                        
                        <Col lg={12} className="text-center mt-5">
                            {sensordata.length > 0 && (
                                <Card>
                                    <CardHeader><h3>{t('Photo')}</h3></CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                                                <h3>{t('Photo')}: {sensordata[currentIndex].id_acquisition}</h3>
                                            </Col>
                                            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                                                <h3>{t('Crop')}: {t(`translation:${sensordata[currentIndex].crop}`)}</h3>
                                            </Col>
                                            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                                                <h3>{t('Variety')}: {sensordata[currentIndex].variety}</h3>
                                            </Col>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                <br></br>
                                            </Col>
                                            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                                                <h3>{t('Number of Grapes')} {sensordata[currentIndex].count}</h3>
                                            </Col>
                                            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                                                <h3>{t('Estimated Weight g')} {sensordata[currentIndex].weight}</h3>  
                                            </Col>
                                            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                                                <h3>{t('Distance')} {sensordata[currentIndex].distance}</h3>  
                                            </Col>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                <br></br>
                                            </Col>
                                        </Row>
                                        {[sensordata[currentIndex].image1_predict, sensordata[currentIndex].image2_predict].map((image, imgIndex) => (
                                            image && 
                                                <>  
                                                    <img key={imgIndex} src={image} alt="Preview" style={{ height: '50%', width: '50%', objectFit: "cover", cursor: "pointer" }} onClick={() => setSelectedImage(image)} />
                                                </>
                                        ))}
                                        <br />
                                        <br />
                                        <Button color='info' onClick={handlePrevImage} disabled={currentIndex === 0}>{t('Previouse')}</Button>
                                        <Button color='dark' onClick={handleNextImage} disabled={currentIndex === sensordata.length - 1}>{t('Next')}</Button>
                                        <br></br>
                                        <br></br>
                                        <Row>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                <h3>{t('Point Data Position')}</h3>
                                                <MapContainer
                                                    center={[sensordata[currentIndex].y_coord, sensordata[currentIndex].x_coord]}
                                                    zoom={17}
                                                    style={{ height: '500px', width: '100%', margin: 0, padding: 0 }}>
                                                    <LayersControl position="topright">
                                                    <LayersControl.BaseLayer checked name="OpenStreetMap">
                                                        <TileLayer
                                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                        attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
                                                        />
                                                    </LayersControl.BaseLayer>
                                                    <LayersControl.BaseLayer checked name="Satellite">
                                                        <TileLayer
                                                        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                                                        attribution="&copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
                                                        />
                                                    </LayersControl.BaseLayer>
                                                    </LayersControl>
                                                    <FeatureGroup key={sensordata[currentIndex].id}>
                                                        <Marker position={[sensordata[currentIndex].y_coord, sensordata[currentIndex].x_coord]} icon={redIcon}>
                                                            <Popup>
                                                                <p>{t('Crop :')} {t(`translation:${sensordata[currentIndex].crop}`)}</p>
                                                                <p>{t('Number of Grape :')} {sensordata[currentIndex].count}</p>
                                                                <p>{t('Date Time of Data Acquisition :')} {format(new Date(sensordata[currentIndex].date), 'PPpp')}</p>                        
                                                                {sensordata[currentIndex].image1 ? <img src={sensordata[currentIndex].image1} alt="Photo 1" style={{ height: '50%', width: '50%', objectFit: 'cover', cursor: 'pointer' }}/> : <p>No photo saved</p> }
                                                                {sensordata[currentIndex].image2 ? <img src={sensordata[currentIndex].image2} alt="Photo 2" style={{ height: '50%', width: '50%', objectFit: 'cover', cursor: 'pointer' }}/> : <p>No photo saved</p> }                      
                                                            </Popup>
                                                        </Marker>
                                                    </FeatureGroup>
                                                </MapContainer>
                                            </Col>
                                        </Row>
                                        <Modal isOpen={!!selectedImage} onRequestClose={() => setSelectedImage(null)}>
                                            {selectedImage && (
                                                <img src={selectedImage} alt="Zoomed" style={{ maxWidth: "90vw", maxHeight: "90vh" }} onClick={() => setSelectedImage(null)} />
                                            )}
                                        </Modal>
                                    </CardBody>
                                </Card>
                            )}
                        </Col>
                    </Row>
                </Container>
            )}
        </div>
    );
}

export default FotoNormalUser;
